import React from "react";
import { useIntl } from "react-intl";

import { BarRow, EmptyState, Panel } from "../../../resusableComponents/funnelFuel";

import { useFilters } from "../lib/FilterContext";

const AudienceColumn = ({ cut, column }) => {
  const intl = useIntl();
  const { toggle, isSelected } = useFilters();

  return (
    <div>
      <h3 className="ff-sub-head ff-caps">{intl.formatMessage({ id: `ff_dashboard.audience.${cut}`, defaultMessage: cut.toUpperCase() })}</h3>
      {!column.rows.length && (
        <EmptyState>{intl.formatMessage({ id: "ff_dashboard.empty.selection", defaultMessage: "Nothing in this selection." })}</EmptyState>
      )}
      {column.rows.map((row) => (
        <BarRow
          key={row.key}
          label={row.label}
          title={row.label}
          value={row.count}
          max={column.max}
          note={`${row.percentage}%`}
          pressed={isSelected(row.selection)}
          onClick={() => toggle(row.selection)}
        />
      ))}
    </div>
  );
};

/*
  Audience delivered: up to three ranked cuts of the same leads. `cuts` is only the ones this campaign collects, so
  a campaign without industry or country just renders fewer columns and the grid reflows with no gap.
*/
export const AudiencePanel = ({ view, cuts }) => {
  const intl = useIntl();

  return (
    <Panel
      title={intl.formatMessage({ id: "ff_dashboard.audience.title", defaultMessage: "Audience delivered" })}
      caption={intl.formatMessage({ id: "ff_dashboard.audience.caption", defaultMessage: "{count} cuts of the same leads · click any bar to filter the page" }, { count: cuts.length })}
    >
      <div className="ff-grid-auto">
        {cuts.map((cut) => <AudienceColumn key={cut} cut={cut} column={view.audience[cut]} />)}
      </div>
    </Panel>
  );
};
